export const GoogleMapApiConfig = 'AIzaSyD3occch5YV-Js8t-bphdEznDthXj42ChU';